module.exports = __webpack_public_path__ + "static/media/24.4b6543b3.png";